import React from 'react';
import { useVersionCheck } from '../hooks/useVersionCheck';

const UpdateBanner: React.FC = () => {
  const { updateAvailable, refresh, dismiss } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center px-4 py-3 bg-gradient-to-r from-purple-700 to-purple-600 text-white shadow-lg animate-slide-down">
      <span className="text-sm font-medium mr-4">✨ A new version is available!</span>
      <button
        onClick={refresh}
        className="px-4 py-1.5 bg-white text-purple-600 text-sm font-semibold rounded-full hover:bg-purple-50 transition-colors mr-2"
      >
        Refresh Now
      </button>
      <button
        onClick={dismiss}
        className="px-3 py-1.5 text-white text-sm hover:underline transition-colors"
      >
        Later
      </button>
    </div>
  );
};

export default UpdateBanner;
